import React, { createContext, useContext } from 'react';

/**
 * Produktdeskriptor der jeweiligen App (`apps/<app>/src/product.js`).
 *
 * Die gemeinsamen Container lesen hierüber die wenigen, bewusst erlaubten
 * Produktunterschiede: Vote-Panel, Darstellung der Projektliste, Teilen-Dienste
 * und die optionalen Slots (Medien, Banner). Alles andere gehört in den Kern,
 * damit die Container ohne Produktweiche auskommen.
 *
 * Der Deskriptor wird von der App-Shell einmal gesetzt. Ohne Provider liefert
 * `useProduct()` ein leeres Objekt, damit die Container auch ohne Produktdaten
 * rendern können; die Container lesen deshalb nur Felder, die sie auch
 * weglassen können.
 */
const ProductContext = createContext({});

export const ProductProvider = ({ value, children }) => (
    <ProductContext.Provider value={value}>{children}</ProductContext.Provider>
);

export const useProduct = () => useContext(ProductContext);
